// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import * as RadixSlider from '@radix-ui/react-slider';

interface IProps {
  defaultValue: number;
  max: number;
  min: number;
  step: number;
  onChange: (v: number) => void;
}

export const Slider = ({ defaultValue, max, min, step, onChange }: IProps) => {
  return (
    <RadixSlider.Root
      className="relative flex items-center w-full h-5"
      defaultValue={[defaultValue]}
      max={max}
      min={min}
      step={step}
      aria-label="Volume"
      onChange={(e) => {
        // @ts-ignore
        onChange(+e.target.value);
      }}
    >
      <RadixSlider.Track className="relative flex-grow h-1 bg-gray-300 rounded-full">
        <RadixSlider.Range className="absolute h-full bg-blue-500 rounded-full" />
      </RadixSlider.Track>
      <RadixSlider.Thumb className="block w-5 h-5 bg-white border border-gray-300 rounded-full shadow-sm hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500" />
    </RadixSlider.Root>
  );
};
